export default __webpack_public_path__ + "static/media/tailwindcss.91bbceb2.svg";